import script from "./xhlzxOrderRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./xhlzxOrderRecord.vue?vue&type=script&setup=true&lang=js"

import "./xhlzxOrderRecord.vue?vue&type=style&index=0&id=7a6ea842&lang=scss"

const __exports__ = script;

export default __exports__